import { colors } from '@globals/themes/defaultTheme'
import { Adornment } from '@kudos/http-client'
import Box from '@mui/material/Box'
import { SxProps } from '@mui/material/styles'
import { cloneElement, type ReactElement } from 'react'
import type { AvatarFontUnit } from './UserAvatar'
import { ADORNMENT_BG_COLOR, ADORNMENT_ICON } from './userAvatarAdornmentUtils'

type AvatarAdornmentBadgeProps = {
  adornment?: Adornment | null
  size: number
  fontUnit: AvatarFontUnit
  isActive?: boolean
}

const AvatarAdornmentBadge: React.FC<AvatarAdornmentBadgeProps> = ({
  adornment,
  size,
  fontUnit,
  isActive = true,
}) => {
  if (!adornment || !isActive) {
    return null
  }

  const unit = (value: number) => `${value}${fontUnit}`
  const badgeSize = size * 0.4
  // Distance from the square’s bottom-left corner in to the circle edge along each axis
  const perimeterInset = (size / 2) * (1 - Math.SQRT1_2)
  const badgeSx: SxProps = {
    position: 'absolute',
    bottom: unit(perimeterInset - badgeSize / 2),
    left: unit(perimeterInset - badgeSize / 2),
    width: unit(badgeSize),
    height: unit(badgeSize),
    borderRadius: '50%',
    backgroundColor: ADORNMENT_BG_COLOR[adornment],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none',
    zIndex: 1,
  }

  return (
    <Box sx={badgeSx}>
      {cloneElement(ADORNMENT_ICON[adornment] as ReactElement<{ sx?: SxProps }>, {
        sx: { fontSize: unit(badgeSize * 0.6), color: colors.white },
      })}
    </Box>
  )
}

export default AvatarAdornmentBadge
